import { VidstackPlayer, VidstackPlayerLayout } from 'vidstack/global/player';
import { withPlugins, device } from '@spon/plugins';

import 'vidstack/player/styles/base.css';
import 'vidstack/player/styles/default/theme.css';
import 'vidstack/player/styles/default/layouts/video.css';

function VideoPlayer({ node, plugins: { device } }) {
	const isBackground = Boolean(node.hasAttribute('data-background'));
	const videoRatio = node.dataset.aspect / 100;
	const { poster } = node.dataset;
	let screenX = window.innerWidth;

	let player;

	function updateSize(el, w, h) {
		el.style.width = `${w}px`;
		el.style.height = `${h}px`;
	}

	function setVideoSize() {
		if (!isBackground || !player) return;

		player.style.width = '';
		player.style.height = '';

		const { width, height } = node.getBoundingClientRect();

		if (width < 1 && height < 1) return;

		// If we're thinner than we are tall, including video ratio, set video to be tall..
		if (height / width > videoRatio) {
			updateSize(player, height / videoRatio, height);
			// .. otherwise we're wider than we are tall, set video to be wide..
		} else {
			updateSize(player, width, width * videoRatio);
		}
	}

	device.resize(() => {
		// Only recalc if we've changed X, not Y!
		// (mobile address bar vibes)
		if (window.innerWidth !== screenX) {
			screenX = window.innerWidth;
			setVideoSize();
		}
	});

	async function init() {
		player = await VidstackPlayer.create({
			target: node.querySelector('iframe, video'),
			layout: new VidstackPlayerLayout({
				autoplay: false,
				volume: 1,
				muted: 0,
			}),
			poster,
			hideControlsOnMouseLeave: true,
		});

		if (isBackground) {
			setVideoSize();
		}

		player.qualities.autoSelect();

		return player;
	}

	const playerInstance = init();

	return () => {
		playerInstance.destroy();
	};
}

export default withPlugins(device)(VideoPlayer);
